import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Aside, { AsideBody } from '../../../components/layouts/Aside/Aside';
import Nav, { NavItemContent } from '../../../components/layouts/Navigation/Nav';
import Loader from '../../../components/ui/Loader';
import PatientDetails from '../../../components/ui/PatientDetails';
import { useApiReload } from '../../../context/apiRelaod';
import { PatientList } from '../../../services/apiService';
import AsideFooterPart from './_parts/AsideFooter.part';
import AsideHeadPart from './_parts/AsideHead.part';
import SimpleLoader from '../../../components/ui/SimpleLoader';
// import SimpleLoader from '../../components/ui/SimpleLoader';

// side bar

const DefaultAsideTemplate = () => {
	const navigate = useNavigate();
	const { response, error, loading, call } = PatientList();

	const { reloadPatient, setReloadPatient } = useApiReload();

	useEffect(() => {
		call().catch((e) => {
			console.log(e);
		});
	}, []);

	useEffect(() => {
		if (reloadPatient) {
			call().catch((e) => {
				console.log(e);
			});
			setReloadPatient(false);
		}
	}, [reloadPatient]);

	return (
		<Aside>
			<AsideHeadPart />
			<AsideBody className='flex w-full py-5'>
				<Nav className='w-full'>
					<NavItemContent>
						{loading ? (
							<div className='flex items-center justify-center px-4 py-12'>
								{/* <Loader /> */}
								<SimpleLoader />
							</div>
						) : (
							<div className='w-full px-2'>
								<PatientDetails />
							</div>
						)}
					</NavItemContent>
				</Nav>
			</AsideBody>
			<AsideFooterPart />
		</Aside>
	);
};

export default DefaultAsideTemplate;
